import { createSelector } from 'reselect';
import { getProjectListState } from 'src/modules/project-list/selectors/getProjectListState';

export const getProjectListExporting = createSelector([
  getProjectListState,
], (state) => state.exporting);
